const cs = {
  layout: {
    cos_button: {
      phone: 'Telefon',
      update_phone_number_message: 'Telefonní číslo bylo úspěšně aktualizováno!'
    },
    time: {
      days: 'Dní',
      hours: 'Hodin',
      mins: 'Minut',
      secs: 'Sekund',
      starts: 'Začíná',
      starts_immediately: 'Začíná ihned'
    },
    field: {
      host: 'Organizátor'
    },
    copy: 'Kopírovat'
  },
  validations: {
    email: 'musí být platný e-mail',
    phone: 'musí být platné telefonní číslo',
    required_field: 'je povinné pole'
  },
  mailer: {
    need_help: 'Potřebujete pomoc?',
    stop_reminders: 'Zrušit odběr připomínek',
    cancel_registration: 'Zrušit registraci',
    report_abuse: 'Nahlásit zneužití'
  },
  datetime: {
    no_sessions: 'Žádné dostupné termíny',
    empty_label: 'Datum/čas'
  },
  errors: {
    verification_failed: 'Ověření se nezdařilo. Zkuste to prosím znovu.',
    session_unavailable: 'Vámi vybraný čas již není dostupný. Zvolte prosím jiný termín.',
    challenge_email_mismatch:
      'Zaregistrujte se prosím se stejným e-mailem, který jste použili při registraci na událost.'
  }
}

export default cs
